import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SubmissionTab } from '../core';

@Injectable({
  providedIn: 'root'
})
export class SubmissionTabsService {
  private _tabs: BehaviorSubject<Map<string, SubmissionTab>> = new BehaviorSubject<Map<string, SubmissionTab>>(new Map<string, SubmissionTab>());

  get tabs(): Observable<SubmissionTab[]> {
    return this._tabs.asObservable().pipe(map((tabsMap: Map<string, SubmissionTab>) => Array.from(tabsMap, ([_, value]) => ({ ...value }))));
  }

  removeTabs(tabIds: string[]): void {
    const tabs = this._tabs.getValue();
    tabIds.forEach((id) => tabs.delete(id));
    this._tabs.next(tabs);
  }

  addTabs(tabs: SubmissionTab[]): void {
    const allTabs = this._tabs.getValue();
    tabs.forEach((tab) => allTabs.set(tab.id, tab));
    this._tabs.next(allTabs);
  }

  removeAllTabs(): void {
    this._tabs.next(new Map<string, SubmissionTab>());
  }

  setTabName(id: string, name: string): void {
    const tabs = this._tabs.getValue();
    const tab = tabs.get(id);
    tabs.set(id, { ...tab, name });
    this._tabs.next(tabs);
  }
}
